"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FileViews = void 0;
var FileViews = exports.FileViews = {
  mobile: 'mobile'
};
var _default = exports["default"] = FileViews;